export const EmailDooDsModal: string = 'EmailDooDsModal';
